// removed by extract-text-webpack-plugin
module.exports = {"ButtonGroup":"ButtonGroup--VoIQK","child":"child--2TsA3"};